import { render, staticRenderFns } from "./DialogAuditDetail.vue?vue&type=template&id=0c16aabb&scoped=true&"
import script from "./DialogAuditDetail.vue?vue&type=script&lang=js&"
export * from "./DialogAuditDetail.vue?vue&type=script&lang=js&"
import style0 from "./DialogAuditDetail.vue?vue&type=style&index=0&id=0c16aabb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c16aabb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c16aabb')) {
      api.createRecord('0c16aabb', component.options)
    } else {
      api.reload('0c16aabb', component.options)
    }
    module.hot.accept("./DialogAuditDetail.vue?vue&type=template&id=0c16aabb&scoped=true&", function () {
      api.rerender('0c16aabb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Activity/components/DialogAuditDetail.vue"
export default component.exports